<div class="mb-3">
  <div>

    <h1 class="pb-2 border-bottom fw-light" i18n>Meldung @if (id) {
<span>(bearbeiten)</span>
}
            @if (!id) {
<span>(anlegen)</span>
}
        </h1>

  <form [formGroup]="blogForm">



    <div class="mb-2">
      <label class="col-sm-2 col-form-label col-form-label-sm ms-3" i18n>Gültig von</label>
      <kendo-datepicker id="validFrom" class="col-sm-3" formControlName="validFrom"></kendo-datepicker>
    </div>

    <div class="mb-2">
      <label class="col-sm-2 col-form-label col-form-label-sm ms-3" i18n>Gültig bis</label>
      <kendo-datepicker id="validTo" class="col-sm-3" formControlName="validTo"></kendo-datepicker>
    </div>

    <div class="mb-2">
      <label class="col-sm-2 col-form-label col-form-label-sm ms-3" i18n>Aktiviert</label>
      <input type="checkbox" formControlName="isActive" #notification kendoCheckBox />
    </div>

    <div class="row">

      <app-form-row label="Text" i18n-label labelClass="col-sm-2 col-form-label col-form-label-sm ms-3">
        <textarea id="body" rows="2" formControlName="body" class="form-control form-control-sm"></textarea>
      </app-form-row>

    </div>

    <button class="btn btn-secondary m-2" type="button" (click)="onBackClicked()" i18n>Zurück</button>
    <button class="btn btn-primary m-2" type="button" [asyncClick]="submitForm.bind(this)" [disabled]="saveBtn.disabled || blogForm.invalid" #saveBtn="asyncClick" i18n>
      @if (saveBtn.busy) { <span class="spinner-border spinner-border-sm me-1"></span> }
      Bestätigen
    </button>

  </form>

</div>
</div>